import React, {useMemo} from 'react';
import {get_biometry_type} from '~/entities/user';
import {cn} from '~/library/ui-kit';
import {isAndroid, isIphoneWithFaceId} from '~/shared/utils/mobileDeviceDetect';
import faceIdIos from './imgs/faceid-ios.svg';
import touchIdAndroid from './imgs/touchid-android.svg';
import touchIdIos from './imgs/touchid-ios.svg';

interface BiometryIconProps {
    inBrowser?: boolean;
    renderTitle?: (biometryType: string) => React.ReactNode;
    renderSubtitle?: (biometryType: string) => React.ReactNode;
}

export function BiometryHead({inBrowser, renderTitle, renderSubtitle}: BiometryIconProps) {
    const biometryTypeName = useMemo(() => {
        if (isAndroid()) {
            return `Touch ID`;
        }
        if (inBrowser) {
            return isIphoneWithFaceId() ? `Face ID` : `Touch ID`;
        }
        if (get_biometry_type() === 'faceId') {
            return 'Face ID';
        }
        return `Touch ID`;
    }, [inBrowser, isAndroid, isIphoneWithFaceId]);

    const imageSrc = useMemo(() => {
        if (isAndroid()) {
            return touchIdAndroid;
        }
        if (inBrowser) {
            return isIphoneWithFaceId() ? faceIdIos : touchIdIos;
        }
        if (get_biometry_type() === 'faceId') {
            return faceIdIos;
        }
        return touchIdIos;
    }, [isAndroid, isIphoneWithFaceId, get_biometry_type, inBrowser]);

    return (
        <div className={'flex flex-1 flex-col gap-6 px-4 pb-4 pt-6'}>
            <div className={'p-4'}>
                <div
                    className={cn([
                        'bg-white mx-auto flex h-[152px] w-[152px]',
                        'items-center justify-center rounded-[20px] bg-neutral-20 p-4',
                    ])}
                >
                    <img src={imageSrc} alt='biometry icon' className={'h-[72px] w-[72px]'} />
                </div>
            </div>
            {(renderTitle || renderSubtitle) && (
                <div className={'flex flex-col items-center gap-2 text-center'}>
                    {renderTitle && (
                        <h2 className={'fv-heading-l text-center text-neutral-100'}>{renderTitle(biometryTypeName)}</h2>
                    )}
                    {renderSubtitle && (
                        <p className={'fv-text-l-regular mt-2 text-center'}>{renderSubtitle(biometryTypeName)}</p>
                    )}
                </div>
            )}
        </div>
    );
}
